<template>
  <div class="wzwxq-page">
    <!-- ================= 左侧常驻模块导航 ================= -->
    <aside class="side-nav" v-if="pageData.modules.length">
      <!-- 模块导航列表：阵容场景下隐藏，仅保留下方标记块入口 -->
      <div class="side-nav__head" v-show="scene === 'ban'">
        <span class="side-nav__title">模块导航</span>
        <span class="side-nav__count">{{ pageData.modules.length }} 个</span>
      </div>
      <ul class="side-nav__list" v-show="scene === 'ban'">
        <li
          v-for="module in pageData.modules"
          :key="`nav_${module.key}`"
        >
          <a
            href="javascript:void(0)"
            class="side-nav__item"
            :class="{ active: activeModuleKey === module.key }"
            @click="scrollToModule(module)"
          >{{ module.title }}</a>
        </li>
      </ul>
      <!-- 阵容场景：左侧改为「主力阵营」筛选项（点击后走接口过滤数据） -->
      <div v-show="scene === 'lineup'" class="side-camp">
        <div class="side-nav__head">
          <span class="side-nav__title">主力阵营</span>
        </div>
        <ul class="side-nav__list side-camp__list">
          <li>
            <a
              href="javascript:void(0)"
              class="side-nav__item"
              :class="{ active: lineupCamp === '' }"
              @click="selectCamp('')"
            >全部</a>
          </li>
          <li v-for="c in campOptions" :key="c">
            <a
              href="javascript:void(0)"
              class="side-nav__item"
              :class="{ active: lineupCamp === c }"
              @click="selectCamp(c)"
            >{{ c }}</a>
          </li>
        </ul>
        <div v-if="lineupCamp" class="side-camp__hint">{{ lineupCamp }}：{{ allLineupCards.length }} 条</div>
      </div>
      <!-- 导航项下方的固定功能块 -->
      <div class="side-nav__footer">
        <!-- 创建阵容：仅阵容场景显示，置于标记块下方 -->
        <el-button
          v-if="scene === 'lineup'"
          type="success"
          plain
          size="small"
          icon="el-icon-plus"
          class="marker-open-btn lineup-create-btn"
          @click="openCreateDialog()"
        >创建阵容</el-button>
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-s-order"
          class="marker-open-btn"
          @click="openMarkerDialog"
        >标记块</el-button>
        <!-- 万象棋知识站：外链模块，点击新标签页打开 wzwxq.com -->
        <a
          class="side-nav__link"
          href="https://wzwxq.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-link"
            class="marker-open-btn"
          >万象棋知识站</el-button>
        </a>
      </div>
    </aside>

    <!-- ================= 右侧主体 ================= -->
    <div class="page-body">
      <!-- 顶部固定区：页面标题 + 场景切换 -->
      <header class="page-header">
        <h1 class="page-title">王者万象棋 · 各阵营禁用环境下 T0 阵容排行</h1>
        <div class="scene-switch" role="tablist">
          <span
            class="scene-switch__item"
            :class="{ active: scene === 'ban' }"
            role="tab"
            @click="switchScene('ban')"
          >禁用场景</span>
          <span
            class="scene-switch__item"
            :class="{ active: scene === 'lineup' }"
            role="tab"
            @click="switchScene('lineup')"
          >阵容场景</span>
        </div>
      </header>

      <!-- 内容滚动区 -->
      <div class="page-scroll">
      <!-- ================= 禁用场景：各禁用环境模块 ================= -->
      <div v-show="scene === 'ban'">
      <section
        v-for="module in pageData.modules"
        :key="module.key"
        class="module-block"
        :data-module-key="module.key"
      >
        <div class="module-head">
          <h2 class="module-title">{{ module.title }}</h2>

          <!-- 移动端：标题右侧展示本模块实际存在的强度色块（无该强度行则不显示） -->
          <div v-if="isMobileView" class="m-tier-legend">
            <span
              v-for="t in moduleTierSet(module)"
              :key="t"
              class="tier-legend-chip"
              :class="tierBadgeClass(t)"
            >{{ t }}</span>
          </div>

          <!-- AI 高频阵容统计：本模块阵容列 → DeepSeek 分析 -->
          <!-- 数据返回时若阵容有增删改（标识变化）先展示表格，AI 统计完成后自动更新此区域 -->
          <div
            class="module-stats"
            v-if="stats[module.key] && stats[module.key].status !== 'pending'"
          >
            <template v-if="stats[module.key].status === 'loading'">
              <span class="stats-note">
                <i class="el-icon-loading"></i>
                AI 正在分析本模块阵容…
              </span>
            </template>
            <template v-else-if="stats[module.key].status === 'ok' && stats[module.key].result.length">
              <span class="stats-label"><i class="el-icon-data-analysis"></i>高频阵容</span>
              <span
                v-for="item in stats[module.key].result"
                :key="item.name"
                class="stats-chip"
                :title="`「${item.name}」在本模块阵容列出现 ${item.count} 次`"
              >{{ item.name }}<b>×{{ item.count }}</b></span>
            </template>
            <template v-else-if="stats[module.key].status === 'ok'">
              <span class="stats-note is-muted">AI：本模块无出现超过 2 次的阵容词眼</span>
            </template>
            <template v-else-if="stats[module.key].status === 'no-key'">
              <span class="stats-note is-muted">未配置 DeepSeek API Key，AI 统计不可用</span>
            </template>
            <template v-else-if="stats[module.key].status === 'failed'">
              <span class="stats-note is-muted">AI 统计失败，可点击右侧图标重试</span>
            </template>
            <i
              class="el-icon-refresh stats-refresh"
              :class="{ 'is-loading': stats[module.key].status === 'loading' }"
              title="强制重新用 AI 统计"
              @click="runModuleStats(module, true)"
            ></i>
          </div>

          <div class="module-actions" v-if="!isMobileView">
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-plus"
              :disabled="isModuleBusy(module)"
              @click="addRow(module)"
            >新增行</el-button>
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-plus"
              :disabled="isModuleBusy(module)"
              @click="addColumn(module)"
            >新增列</el-button>
          </div>
        </div>

        <div class="table-wrap" v-loading="loading">
          <!-- 桌面端：多列表格 -->
          <el-table
            v-if="!isMobileView"
            :data="sortedModuleRows(module)"
            max-height="440"
            border
            size="small"
            class="wzwxq-table"
          >
            <!-- 动态列：首列 strength 冻结，其余列按 columns 渲染 -->
            <el-table-column
              v-for="col in module.columns"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
              :min-width="col.minWidth"
              :fixed="col.fixed ? 'left' : false"
            >
              <!-- 列头：新增列录入态时显示确认/取消 -->
              <template slot="header">
                <span v-if="isColAdding(module, col)" class="col-head-editing">
                  <el-button
                    type="text"
                    icon="el-icon-check"
                    class="col-confirm-btn"
                    @click="confirmAddColumn(module, col)"
                  />
                  <el-button
                    type="text"
                    icon="el-icon-close"
                    class="col-cancel-btn"
                    @click="cancelAddColumn(module, col)"
                  />
                </span>
                <span v-else>{{ col.label }}</span>
              </template>

              <!-- 单元格：行新增 / 行编辑 / 新增列 → 录入控件；展示态直接展示 -->
              <template slot-scope="{ row }">
                <div
                  class="cell-wrap"
                  :class="{ 'is-editing': isRowAdding(module, row) || isRowEditing(module, row) || isColAdding(module, col) }"
                >
                  <template v-if="isRowAdding(module, row) || isRowEditing(module, row) || isColAdding(module, col)">
                    <el-select
                      v-if="col.type === 'strength'"
                      v-model="draftValues[cellKey(module, row, col)]"
                      size="mini"
                      placeholder="选择强度"
                      class="cell-control"
                    >
                      <el-option
                        v-for="s in strengthOptions"
                        :key="s"
                        :label="s"
                        :value="s"
                      />
                    </el-select>

                    <el-date-picker
                      v-else-if="col.type === 'date'"
                      v-model="draftValues[cellKey(module, row, col)]"
                      type="date"
                      value-format="yyyy-MM-dd"
                      size="mini"
                      placeholder="选择日期"
                      class="cell-control"
                    />

                    <!-- 打法/要点：编辑态展示原始纯文本，便于修改后重新匹配高亮 -->
                    <el-input
                      v-else-if="col.prop === 'detail'"
                      v-model="draftValues[cellKey(module, row, col)]"
                      type="textarea"
                      :rows="2"
                      :autosize="{ minRows: 2, maxRows: 8 }"
                      size="mini"
                      placeholder="请输入"
                      class="cell-control"
                    />

                    <el-input
                      v-else
                      v-model="draftValues[cellKey(module, row, col)]"
                      size="mini"
                      placeholder="请输入"
                      class="cell-control"
                    />
                  </template>

                  <!-- 展示态 -->
                  <template v-else>
                    <!-- 强度色块 -->
                    <span
                      v-if="col.type === 'strength' && row[col.prop]"
                      class="tier-badge"
                      :class="tierBadgeClass(row[col.prop])"
                    >{{ row[col.prop] }}</span>
                    <!-- 记录日期：蓝色色块 -->
                    <span
                      v-else-if="col.type === 'date' && row[col.prop]"
                      class="date-pill"
                    >{{ row[col.prop] }}</span>
                    <!-- 打法/要点：内容为图片 URL → el-image 展示；否则纯文本中命中词条 → 色块高亮 -->
                    <template v-else-if="col.prop === 'detail'">
                      <el-image
                        v-if="isImageUrl(row[col.prop])"
                        class="detail-image"
                        :src="String(row[col.prop]).trim()"
                        :preview-src-list="[String(row[col.prop]).trim()]"
                        fit="contain"
                        lazy
                      />
                      <span v-else-if="row[col.prop]" class="detail-rich">
                        <template v-for="(tok, i) in matchDetailTokens(row[col.prop])">
                          <span
                            v-if="tok.type === 'tag'"
                            :key="`tag_${i}`"
                            class="marker-chip"
                            :style="markerChipStyle(tok)"
                          >{{ tok.content }}</span>
                          <span v-else :key="`txt_${i}`">{{ tok.content }}</span>
                        </template>
                      </span>
                      <span v-else>—</span>
                    </template>
                    <!-- 阵容：单行文本（超长省略号，悬浮看全文） -->
                    <span
                      v-else-if="col.prop === 'lineup'"
                      class="cell-text is-nowrap"
                      :title="row[col.prop]"
                    >{{ row[col.prop] || '—' }}</span>
                    <span v-else class="cell-text">{{ row[col.prop] || '—' }}</span>
                  </template>
                </div>
              </template>
            </el-table-column>

            <!-- 操作列：新增/编辑态确认取消；普通态 修改 + 删除 -->
            <el-table-column label="操作" :width="110" align="center" fixed="right">
              <template slot-scope="{ row }">
                <template v-if="isRowAdding(module, row)">
                  <el-button
                    type="text"
                    icon="el-icon-check"
                    class="row-confirm-btn"
                    title="确认新增"
                    @click.stop="confirmAddRow(module, row)"
                  />
                  <el-button
                    type="text"
                    icon="el-icon-close"
                    class="row-cancel-btn"
                    title="取消新增"
                    @click.stop="cancelAddRow(module, row)"
                  />
                </template>
                <template v-else-if="isRowEditing(module, row)">
                  <el-button
                    type="text"
                    icon="el-icon-check"
                    class="row-confirm-btn"
                    title="保存修改"
                    @click.stop="confirmRowEdit(module, row)"
                  />
                  <el-button
                    type="text"
                    icon="el-icon-close"
                    class="row-cancel-btn"
                    title="取消修改"
                    @click.stop="cancelRowEdit(module, row)"
                  />
                </template>
                <template v-else>
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    class="row-edit-btn"
                    title="编辑该行"
                    @click.stop="startRowEdit(module, row)"
                  />
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    class="row-delete-btn"
                    title="删除该行"
                    @click.stop="deleteRow(module, row)"
                  />
                </template>
              </template>
            </el-table-column>
          </el-table>

          <!-- 移动端：单列（阵容/打法要点）卡片式列表，占满整宽 -->
          <div v-else class="mobile-rows">
            <div class="mobile-col-head">阵容 / 打法要点</div>
            <div
              v-for="row in sortedModuleRows(module)"
              :key="row.rowId"
              class="m-row"
            >
              <div class="m-row__lineup">
                <span
                  v-if="row.strength"
                  class="lineup-badge"
                  :class="tierBadgeClass(row.strength)"
                >{{ row.lineup || '—' }}</span>
                <span v-else class="m-row__lineup-text">{{ row.lineup || '—' }}</span>
              </div>
              <div v-if="row.detail" class="m-row__detail">
                <!-- 图片 URL → 直接展示图片 -->
                <el-image
                  v-if="isImageUrl(row.detail)"
                  class="detail-image"
                  :src="String(row.detail).trim()"
                  :preview-src-list="[String(row.detail).trim()]"
                  fit="contain"
                  lazy
                />
                <template v-else v-for="(tok, i) in matchDetailTokens(row.detail)">
                  <span
                    v-if="tok.type === 'tag'"
                    :key="`mtag_${i}`"
                    class="marker-chip"
                    :style="markerChipStyle(tok)"
                  >{{ tok.content }}</span>
                  <span v-else :key="`mtxt_${i}`">{{ tok.content }}</span>
                </template>
              </div>
              <div v-else class="m-row__detail">—</div>
            </div>
          </div>
        </div>
      </section>
      </div>

      <!-- ================= 阵容场景：每行阵容一张卡片 ================= -->
      <div v-show="scene === 'lineup'" class="lineup-view">
        <div class="lineup-toolbar">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="openCreateDialog"
          >创建阵容</el-button>
        </div>
        <div class="lineup-cards">
          <div
            v-for="(item, i) in allLineupCards"
            :key="`lc_${item.module.key}_${item.row.rowId}_${i}`"
            class="lineup-card"
            :class="{ 'is-detail': item.row.articleType === '详细' }"
          >
            <div
              class="lc-title"
              title="点击编辑该阵容"
              @click.stop="openCreateDialog(item)"
            >{{ item.row.lineup || '—' }}</div>
            <!-- 详细类型：顶部 tab 分节展示 -->
            <div v-if="item.row.articleType === '详细'" class="lc-detail-tabs">
              <el-tabs v-model="item._tab" class="lc-tabs">
                <el-tab-pane
                  v-for="field in detailFields"
                  :key="field.key"
                  :label="field.label"
                  :name="field.key"
                >
                  <div class="lc-tab-content">
                    <template v-if="item.row[field.key]">
                      <template v-for="(tok, j) in matchDetailTokens(item.row[field.key])">
                        <span
                          v-if="tok.type === 'tag'"
                          :key="`lt_${j}`"
                          class="marker-chip"
                          :style="markerChipStyle(tok)"
                        >{{ tok.content }}</span>
                        <span v-else :key="`lx_${j}`">{{ tok.content }}</span>
                      </template>
                    </template>
                    <span v-else class="lc-tab-empty">暂无内容</span>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <!-- 简易类型：打法/要点 -->
            <div v-else-if="item.row.detail" class="lc-detail">
              <el-image
                v-if="isImageUrl(item.row.detail)"
                class="detail-image is-card"
                :src="String(item.row.detail).trim()"
                :preview-src-list="[String(item.row.detail).trim()]"
                fit="contain"
                lazy
              />
              <template v-else v-for="(tok, j) in matchDetailTokens(item.row.detail)">
                <span
                  v-if="tok.type === 'tag'"
                  :key="`lct_${j}`"
                  class="marker-chip"
                  :style="markerChipStyle(tok)"
                >{{ tok.content }}</span>
                <span v-else :key="`lcx_${j}`">{{ tok.content }}</span>
              </template>
            </div>
            <div v-else class="lc-detail">—</div>
            <div class="lc-foot">
              <div class="lc-foot__left">
                <template v-for="(cp, ci) in campArray(item.row.camp)">
                  <span
                    :key="`camp_${ci}_${cp}`"
                    class="camp-chip"
                    :style="campChipStyle(cp)"
                  >{{ cp }}</span>
                </template>
                <span
                  v-if="item.row.strength"
                  class="lc-strength"
                  :class="tierBadgeClass(item.row.strength)"
                >{{ item.row.strength }}</span>
              </div>
              <span v-if="item.row.date" class="lc-date">{{ item.row.date }}</span>
            </div>
          </div>
          <div v-if="!allLineupCards.length" class="lineup-empty">暂无阵容数据</div>
        </div>
      </div>
      </div>
    </div>

    <!-- ================= 创建阵容弹窗 ================= -->
    <el-dialog
      title="创建阵容"
      :visible.sync="createDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      class="create-lineup-dialog"
    >
      <div class="create-form">
        <!-- 滚动容器：内容超出时在内部滚动，不撑高弹窗 -->
        <div class="create-form-scroll">
        <div class="create-form__row">
          <span class="create-form__label">所属环境</span>
          <el-select
            v-model="createForm.moduleKey"
            size="small"
            class="create-form__control"
            placeholder="可不选（归入未分类）"
          >
            <el-option
              v-for="m in pageData.modules"
              :key="m.key"
              :label="m.title"
              :value="m.key"
            />
          </el-select>
        </div>
        <div class="create-form__row">
          <span class="create-form__label">强度</span>
          <el-select
            v-model="createForm.strength"
            size="small"
            class="create-form__control"
            placeholder="可不选"
          >
            <el-option
              v-for="s in strengthOptions"
              :key="s"
              :label="s"
              :value="s"
            />
          </el-select>
        </div>
        <div class="create-form__row">
          <span class="create-form__label">阵容</span>
          <el-input
            v-model.trim="createForm.lineup"
            size="small"
            maxlength="30"
            placeholder="请输入阵容名称"
            class="create-form__control"
          />
        </div>
        <div class="create-form__row">
          <span class="create-form__label">主力阵营</span>
          <el-select
            v-model="createForm.camp"
            multiple
            size="small"
            class="create-form__control"
            placeholder="可多选：三分 / 日落海 / 逐鹿 / 大河 / 河洛 / 无阵营"
          >
            <el-option
              v-for="c in campOptions"
              :key="c"
              :label="c"
              :value="c"
            />
          </el-select>
        </div>
        <div class="create-form__row">
          <span class="create-form__label">文章类型</span>
          <el-radio-group v-model="createForm.articleType" size="small">
            <el-radio-button label="简易" />
            <el-radio-button label="详细" />
          </el-radio-group>
        </div>
        <!-- 简易：打法/要点 -->
        <div v-if="createForm.articleType !== '详细'" class="create-form__row">
          <span class="create-form__label">打法/要点</span>
          <el-input
            v-model="createForm.detail"
            type="textarea"
            :rows="4"
            size="small"
            placeholder="请输入打法要点；可粘贴图片 URL 以图片展示"
            class="create-form__control"
          />
        </div>
        <!-- 详细：五个分节文本域 -->
        <template v-else>
          <div
            v-for="field in detailFields"
            :key="field.key"
            class="create-form__row"
          >
            <span class="create-form__label">{{ field.label }}</span>
            <el-input
              v-model="createForm[field.key]"
              type="textarea"
              :rows="field.key === 'lineupHeroes' ? 3 : 4"
              size="small"
              :placeholder="`请输入${field.label}${field.required ? '' : '（可不填）'}`"
              class="create-form__control"
            />
          </div>
        </template>
        <div class="create-form__row">
          <span class="create-form__label">日期</span>
          <el-date-picker
            v-model="createForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            size="small"
            placeholder="留空则默认当前时间"
            class="create-form__control"
          />
        </div>
        </div>
      </div>
      <div slot="footer" class="create-form__footer">
        <!-- 编辑已有阵容时提供删除 -->
        <el-button
          v-if="editingCardKey"
          size="small"
          type="danger"
          plain
          icon="el-icon-delete"
          class="create-form__del"
          @click="deleteEditingLineup"
        >删除</el-button>
        <span class="create-form__footer-space"></span>
        <el-button size="small" @click="createDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitCreateLineup">{{ editingCardKey ? '保存修改' : '确定创建' }}</el-button>
      </div>
    </el-dialog>

    <!-- ================= 标记块维护弹窗 ================= -->
    <el-dialog
      title="标记块 · 词条色块维护"
      :visible.sync="markerDialogVisible"
      width="680px"
      :close-on-click-modal="false"
      class="marker-dialog"
      @opened="lockBackgroundScroll"
      @closed="unlockBackgroundScroll"
    >
      <div class="marker-dialog__tip">
        词条会按名称自动匹配表格「打法/要点」列文本并高亮为色块；修改行内容保存后会自动重新匹配。点击色块可改名/改色，组内可新增词条；也可新增类型（分组）。
      </div>

      <!-- 新增类型：固定，不随类型列表滚动 -->
      <div class="marker-category-add">
        <template v-if="addingCategory">
          <el-input
            v-model="editCategoryName"
            size="mini"
            class="marker-edit-name"
            maxlength="10"
            placeholder="新类型名称，如：套路"
            @keyup.enter.native="commitCategoryAdd"
          />
          <el-color-picker
            v-model="editCategoryColor"
            size="mini"
            class="marker-edit-color"
            :predefine="markerPredefine"
          />
          <el-button type="text" icon="el-icon-check" class="row-confirm-btn" title="确定" @click="commitCategoryAdd" />
          <el-button type="text" icon="el-icon-close" class="row-cancel-btn" title="取消" @click="cancelCategoryAdd" />
          <span class="marker-category-add__hint">颜色可不选，保存时由后端自动分配未占用颜色</span>
        </template>
        <el-button
          v-else
          type="primary"
          plain
          size="mini"
          icon="el-icon-plus"
          class="marker-category-add__btn"
          @click="startAddCategory"
        >新增类型</el-button>
      </div>

      <!-- 类型数据区：新增类型按钮以下的所有类型分组，超出时内部滚动 -->
      <div class="marker-scroll">
      <div
        v-for="cat in dialogCategories"
        :key="cat.name"
        class="marker-group"
      >
        <div class="marker-group__head">
          <span class="marker-group__dot" :style="{ backgroundColor: cat.color }"></span>
          <span class="marker-group__name">{{ cat.name }}</span>
          <span class="marker-group__count">{{ groupMarkers(cat.name).length }}</span>
          <el-button
            v-if="!groupMarkers(cat.name).length"
            type="text"
            icon="el-icon-delete"
            class="marker-cat-del-btn"
            :title="`删除类型「${cat.name}」（需组内无词条）`"
            @click="deleteCategory(cat)"
          />
          <el-button
            type="text"
            icon="el-icon-plus"
            class="marker-group__add"
            :disabled="Boolean(editingMarkerId)"
            @click="startAddMarker(cat)"
          >新增</el-button>
        </div>
        <div class="marker-group__body">
          <span
            v-for="m in groupMarkers(cat.name)"
            :key="m.id"
            class="marker-item"
          >
            <!-- 编辑/新增行 -->
            <template v-if="editingMarkerId === m.id">
              <el-input
                v-model="editMarkerName"
                size="mini"
                class="marker-edit-name"
                maxlength="12"
                placeholder="词条名称"
                @keyup.enter.native="commitMarkerEdit(m)"
              />
              <el-color-picker
                v-model="editMarkerColor"
                size="mini"
                class="marker-edit-color"
                :predefine="markerPredefine"
              />
              <el-button type="text" icon="el-icon-check" class="row-confirm-btn" title="确定" @click="commitMarkerEdit(m)" />
              <el-button type="text" icon="el-icon-close" class="row-cancel-btn" title="取消" @click="cancelMarkerEdit(m)" />
              <el-button
                v-if="!m.isNew"
                type="text"
                icon="el-icon-delete"
                class="marker-del-btn"
                title="删除该词条"
                @click="deleteMarker(m)"
              />
            </template>
            <!-- 展示色块：点击进入编辑 -->
            <span
              v-else
              class="marker-chip"
              :class="{ 'is-in-dialog': true }"
              :style="markerStyleOf(m)"
              :title="`点击编辑「${m.name}」`"
              @click="startEditMarker(m)"
            >{{ m.name }}</span>
          </span>
          <span
            v-if="!groupMarkers(cat.name).length && editingMarkerId !== '__new_' + cat.name"
            class="marker-group__empty"
          >暂无词条，点右上角「新增」添加</span>
        </div>
      </div>
      </div>

      <div slot="footer" class="marker-dialog__footer">
        <span class="marker-dialog__hint">共 {{ markersDraft.length }} 个词条 / {{ dialogCategories.length }} 个类型，保存后全表重新匹配</span>
        <el-button size="small" @click="markerDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveMarkers">保存标记块</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchWzwxqData, saveWzwxqData } from '../../../api/modules/wzwxq'
import { isMobileDevice } from '../../../utils/device'

/**
 * 王者万象棋 · 各阵营禁用环境下 T0 阵容排行
 * =============================================
 * 数据来源：得到大脑(Get笔记) 笔记《王者万象棋各阵营禁用环境下T0阵容排行与玩家讨论》
 *   - 由后端 GET /api/wzwxq 加载；新增/编辑/删除行、新增列确认后，
 *     立即 PUT /api/wzwxq 全量回存（全部数据变更都走后端接口）。
 *
 * 【数据模型】
 * 每个模块 = 一个禁用环境（禁河洛/禁逐鹿/禁三分/禁日落海/禁大河），
 * 行 = 一个阵容条目；列 = 维度（columns 驱动，动态渲染）。
 * 列类型：strength（强度，冻结首列）/ date（日期）/ text（文本）。
 *
 * 【交互】
 * - 新增行插入到表格首行；新增/编辑/删除均落库。
 * - 单元格展示态不含铅笔图标，「修改」统一收敛到操作栏：
 *   点击后整行进入录入态（各列按类型显示控件），操作栏打勾保存/打叉取消。
 * - 来源列（source）已在加载与持久化前剔除。
 * - 强度列 T0/T1/T2/T3 以色块胶囊展示，高级别更醒目。
 *
 * 【AI 高频阵容统计（参考 AI → DeepSeek 问答 demo 的直连方式）】
 * - 读取 localStorage deepseek_demo_config（apiKey/model），
 *   把每个模块「阵容」列的值组成数组发给 DeepSeek
 *   （api.deepseek.com/chat/completions）统计出现超过 2 次的阵容词眼。
 * - 指纹机制：对每个模块的阵容列计算签名（每条阵容作为标识参与比对），
 *   签名缓存于 localStorage。每次表格数据返回/变更后先判断签名：
 *   - 签名与上次统计一致（没多没少）→ 直接复用上次统计结果，不重复请求 AI；
 *   - 签名变化（新增/删除/修改了阵容）→ 先把表格数据展示出来，
 *     统计区域保持隐藏，随后请求 AI，返回后再更新统计展示。
 * - 用户新增/修改行后，先调用保存接口，成功后自动重算本模块统计。
 */
const DEEPSEEK_API_URL = 'https://api.deepseek.com/chat/completions'
const DEEPSEEK_STORAGE_KEY = 'deepseek_demo_config'
const STATS_CACHE_KEY = 'wzwxq_lineup_stats_v1'
const DEEPSEEK_TIMEOUT = 30000

/**
 * 标记块：四类词条分组（默认类别色）。
 */
const MARKER_CATEGORIES = [
  { name: '禁用', color: '#e53935' },
  { name: '英雄', color: '#43a047' },
  { name: '装备', color: '#1e88e5' },
  { name: '玩法', color: '#fb8c00' },
  { name: '棋手', color: '#8e24aa' },
]

/** 首次使用（后端无词条）时的默认词条库 */
const DEFAULT_MARKERS = [
  { id: 'mk_1', name: '禁三分', category: '禁用', color: '#e53935' },
  { id: 'mk_2', name: '禁日落海', category: '禁用', color: '#e53935' },
  { id: 'mk_3', name: '露娜', category: '英雄', color: '#43a047' },
  { id: 'mk_4', name: '孙尚香', category: '英雄', color: '#43a047' },
  { id: 'mk_5', name: '刘禅', category: '英雄', color: '#43a047' },
  { id: 'mk_6', name: '养猪', category: '玩法', color: '#fb8c00' },
  { id: 'mk_7', name: '逐鹿', category: '玩法', color: '#fb8c00' },
  { id: 'mk_8', name: '三分倒转', category: '玩法', color: '#fb8c00' },
  { id: 'mk_9', name: '大河', category: '玩法', color: '#fb8c00' },
  { id: 'mk_10', name: '日落海', category: '玩法', color: '#fb8c00' },
  { id: 'mk_11', name: '闹闹', category: '棋手', color: '#8e24aa' },
  { id: 'mk_12', name: '班叔', category: '棋手', color: '#8e24aa' },
]

/** 颜色选择器预置色板 */
const MARKER_PREDEFINE = ['#e53935', '#43a047', '#1e88e5', '#fb8c00', '#8e24aa', '#d81b60', '#00acc1', '#f4511e', '#3949ab']

/** 主力阵营选项与固定配色 */
const CAMP_OPTIONS = ['三分', '日落海', '逐鹿', '大河', '河洛', '无阵营']
const CAMP_COLORS = {
  三分: '#9c27b0',
  日落海: '#26a69a',
  逐鹿: '#5c6bc0',
  大河: '#1e88e5',
  河洛: '#ec407a',
  无阵营: '#90a4ae',
}

/**
 * 文章类型：simple=简易（仅打法/要点） / detail=详细（五个分节 tab）
 */
const ARTICLE_TYPES = ['简易', '详细']

/** 详细类型的分节字段（tab 与表单均按此顺序渲染）；lineupHeroes 为必填 */
const DETAIL_FIELDS = [
  { key: 'lineupHeroes', label: '阵容英雄', required: true },
  { key: 'equipment', label: '天赋装备', required: false },
  { key: 'operation', label: '运营', required: false },
  { key: 'keyTips', label: '关键技巧', required: false },
  { key: 'supplement', label: '补充细节', required: false },
]

export default {
  name: 'WzwxqIndex',
  data() {
    return {
      loading: false,
      saving: false,
      pageData: {
        sourceNote: '',
        sourceNoteId: '',
        modules: [],
      },
      strengthOptions: ['T0', 'T1', 'T2', 'T3'],
      // 新增行录入态：{ [moduleKey]: rowId }
      addingRows: {},
      // 行编辑录入态：{ [moduleKey]: rowId }
      editingRows: {},
      // 新增列录入态：{ [moduleKey]: colProp }
      addingCols: {},
      // 各单元格录入草稿：key = `${moduleKey}::${rowId}::${prop}`
      draftValues: {},
      // AI 统计状态：{ [moduleKey]: { status, result } }
      // status: pending(数据变化待统计/首次加载) | loading | ok | no-key | failed
      stats: {},
      // 标记块类型列表（已保存到后端的当前值）
      categories: [],
      // 标记块词条库（已保存到后端的当前值）
      markers: [],
      // 标记块维护弹窗状态
      markerDialogVisible: false,
      markersDraft: [],
      // 弹窗内类型草稿（保存按钮才落库）
      dialogCategories: [],
      // 新增类型行状态
      addingCategory: false,
      editCategoryName: '',
      editCategoryColor: '',
      editingMarkerId: null,
      editMarkerName: '',
      editMarkerColor: '',
      // 滚动监听器/滚动容器引用
      scrollContainer: null,
      scrollHandler: null,
      // 当前视口内模块 key（左侧导航高亮）
      activeModuleKey: '',
      // 场景切换：lineup=阵容场景(默认) / ban=禁用场景
      scene: 'lineup',
      // 阵容场景：主力阵营筛选（''=全部）；选中非空时通过后端接口过滤
      lineupCamp: '',
      // 接口过滤后的阵容卡片（null = 未过滤，使用本地全量数据）
      lineupRows: null,
      // 创建/编辑阵容弹窗
      createDialogVisible: false,
      editingCardKey: '',
      createForm: {
        moduleKey: '',
        strength: '',
        lineup: '',
        camp: [],
        articleType: '简易',
        detail: '',
        lineupHeroes: '',
        equipment: '',
        operation: '',
        keyTips: '',
        supplement: '',
        date: '',
      },
    }
  },
  computed: {
    markerCategories() {
      // 类型以后端 categories 数据为准；为空时兜底内置五类
      return this.categories.length ? this.categories : MARKER_CATEGORIES
    },
    markerPredefine() {
      return MARKER_PREDEFINE
    },
    campOptions() {
      return CAMP_OPTIONS
    },
    articleTypes() {
      return ARTICLE_TYPES
    },
    detailFields() {
      return DETAIL_FIELDS
    },
    // 移动端展示模式（分辨率/UA 判定，进入页面时确定）
    isMobileView() {
      return isMobileDevice()
    },
    // 阵容场景卡片：优先取接口过滤结果；未过滤时用本地全量行，
    // 均按强度优先、同强度日期倒序
    allLineupCards() {
      if (this.lineupRows) return this.lineupRows
      return this.buildLineupCards(this.pageData.modules)
    },
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.$nextTick(() => this.initScrollSpy())
  },
  activated() {
    // keep-alive 重新激活时重建滚动监听并同步高亮
    this.$nextTick(() => {
      this.initScrollSpy()
    })
  },
  beforeDestroy() {
    this.destroyScrollSpy()
    // 中断未完成的 AI 统计请求
    this.abortAllStats()
  },
  methods: {
    // ─── 数据加载、清洗与回存 ───────────────────────
    async loadData() {
      this.loading = true
      try {
        const data = await fetchWzwxqData()
        this.normalizePageData(data)
        this.pageData = data || this.pageData
        this.initMeta(data)
        this.settleAllStats()
      } catch (error) {
        this.$toast.error(`数据加载失败：${error.message}`)
      } finally {
        this.loading = false
      }
    },

    /**
     * 数据落地规整（兼容旧数据结构）：
     * 1. 剔除「来源 source」列及行内 source 字段；
     * 2. 非冻结列统一 width → minWidth，使表格在容器内自动撑满；
     * 3. 冻结列保留固定 width（fixed 需要固定宽度才能生效）。
     */
    normalizePageData(data) {
      if (!data || !Array.isArray(data.modules)) return
      data.modules.forEach((module) => {
        module.columns = (module.columns || [])
          .filter(col => col && col.prop !== 'source')
          .map((col) => {
            const normalized = {
              prop: col.prop,
              label: col.label,
              type: col.type || 'text',
            }
            if (col.fixed) {
              normalized.fixed = true
              normalized.width = col.width || 110
            } else if (col.prop === 'lineup') {
              // 阵容列：固定宽度容纳完整阵容名，不参与弹性拉伸
              normalized.width = col.width || 180
            } else if (col.prop === 'date') {
              // 记录日期列：窄固定宽度，恰好容纳 2026-08-29
              normalized.width = col.width || 118
            } else {
              // 打法/要点等正文列：minWidth 弹性，把表格剩余宽度吸走
              normalized.minWidth = col.minWidth || col.width || 140
            }
            return normalized
          })
        ;(module.rows || []).forEach((row) => {
          delete row.source
        })
      })
    },

    async persist() {
      this.saving = true
      try {
        const saved = await saveWzwxqData({
          sourceNote: this.pageData.sourceNote,
          sourceNoteId: this.pageData.sourceNoteId,
          categories: this.categories,
          markers: this.markers,
          modules: this.pageData.modules,
        })
        // 后端可能为新类型/缺色类型随机分配了颜色，回写本地
        if (saved && Array.isArray(saved.categories) && saved.categories.length) {
          this.categories = saved.categories
        }
        return saved
      } catch (error) {
        this.$toast.error(`保存失败：${error.message}`)
      } finally {
        this.saving = false
      }
    },

    /**
     * 渲染用行序：优先按强度 T0>T1>T2>T3，同强度按记录日期倒序（新在前）；
     * 正在录入中的行（新增/编辑）始终置顶，便于操作。
     */
    sortedModuleRows(module) {
      const rows = (module && module.rows) || []
      if (!rows.length) return rows
      const busyId = this.addingRows[module.key] || this.editingRows[module.key]
      const busyRow = busyId ? rows.find(r => r.rowId === busyId) : null
      const others = busyRow ? rows.filter(r => r.rowId !== busyId) : rows
      const order = { T0: 0, T1: 1, T2: 2, T3: 3 }
      const sorted = [...others].sort((a, b) => {
        const sa = a.strength !== undefined && order[a.strength] !== undefined ? order[a.strength] : 4
        const sb = b.strength !== undefined && order[b.strength] !== undefined ? order[b.strength] : 4
        if (sa !== sb) return sa - sb
        const da = a.date || ''
        const db = b.date || ''
        if (!da && !db) return 0
        if (!da) return 1
        if (!db) return -1
        return da < db ? 1 : da > db ? -1 : 0
      })
      return busyRow ? [busyRow, ...sorted] : sorted
    },

    // ─── 状态判定辅助 ─────────────────────────────────
    cellKey(module, row, col) {
      return `${module.key}::${row.rowId}::${col.prop}`
    },

    isRowAdding(module, row) {
      return this.addingRows[module.key] === row.rowId
    },

    isRowEditing(module, row) {
      return this.editingRows[module.key] === row.rowId
    },

    isColAdding(module, col) {
      return this.addingCols[module.key] === col.prop
    },

    // 模块是否处于任意录入态（新增行 / 行编辑 / 新增列互斥）
    isModuleBusy(module) {
      return Boolean(
        this.addingRows[module.key] ||
        this.editingRows[module.key] ||
        this.addingCols[module.key]
      )
    },

    // ─── 行编辑（操作栏 修改 → 整行录入 → 打勾/取消） ─
    startRowEdit(module, row) {
      if (this.isModuleBusy(module)) return
      module.columns.forEach((col) => {
        this.$set(this.draftValues, this.cellKey(module, row, col), row[col.prop] || '')
      })
      this.$set(this.editingRows, module.key, row.rowId)
    },

    confirmRowEdit(module, row) {
      let invalid = false
      module.columns.forEach((col) => {
        const key = this.cellKey(module, row, col)
        const val = this.draftValues[key]
        if (col.type === 'strength' && val && !this.strengthOptions.includes(val)) {
          invalid = true
        }
      })
      if (invalid) {
        this.$toast.warning('强度取值需在 T0/T1/T2/T3 中')
        return
      }

      // 编辑校验：强度/阵容/打法要点 三字段必填；日期可空（空则默认当前时间）
      for (const col of module.columns) {
        const val = String(this.draftValues[this.cellKey(module, row, col)] || '').trim()
        if (col.type === 'strength' && !val) {
          this.$toast.warning('「强度」为必填项，请选择 T0-T3')
          return
        }
        if ((col.prop === 'lineup' || col.prop === 'detail') && !val) {
          this.$toast.warning(`「${col.label}」为必填项`)
          return
        }
      }

      module.columns.forEach((col) => {
        const key = this.cellKey(module, row, col)
        let val = this.draftValues[key] || ''
        // 编辑时日期为空 → 默认取当前时间
        if (col.type === 'date' && !val) val = this.todayString()
        this.$set(row, col.prop, val)
        this.$delete(this.draftValues, key)
      })
      this.$delete(this.editingRows, module.key)
      // 先落库，成功后再按阵容标识变化决定是否重新 AI 统计
      this.persist().then(() => this.refreshModuleStats(module))
    },

    cancelRowEdit(module, row) {
      // 行数据未被改动，仅清除草稿即恢复原值展示
      module.columns.forEach((col) => {
        this.$delete(this.draftValues, this.cellKey(module, row, col))
      })
      this.$delete(this.editingRows, module.key)
    },

    /** 当天日期 YYYY-MM-DD */
    todayString() {
      const d = new Date()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${d.getFullYear()}-${mm}-${dd}`
    },

    // ─── 新增行（插入首行） ───────────────────────────
    addRow(module) {
      if (this.isModuleBusy(module)) return
      const rowId = `new_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
      const row = { rowId }
      const initialDefaults = { strength: 'T0' } // 新增行强度默认 T0
      module.columns.forEach((col) => {
        const initVal = initialDefaults[col.prop] !== undefined ? initialDefaults[col.prop] : ''
        row[col.prop] = initVal
        this.$set(this.draftValues, this.cellKey(module, row, col), initVal)
      })
      module.rows.unshift(row)
      this.$set(this.addingRows, module.key, rowId)
    },

    confirmAddRow(module, row) {
      module.columns.forEach((col) => {
        const key = this.cellKey(module, row, col)
        let val = this.draftValues[key] || ''
        // 新增时日期为空 → 默认当前时间；强度为空 → T0
        if (col.type === 'date' && !val) val = this.todayString()
        if (col.type === 'strength' && !val) val = 'T0'
        this.$set(row, col.prop, val)
        this.$delete(this.draftValues, key)
      })
      this.$delete(this.addingRows, module.key)
      // 先落库，成功后再按阵容标识变化决定是否重新 AI 统计
      this.persist().then(() => this.refreshModuleStats(module))
    },

    cancelAddRow(module, row) {
      const idx = module.rows.indexOf(row)
      if (idx > -1) {
        module.rows.splice(idx, 1)
      }
      module.columns.forEach((col) => {
        this.$delete(this.draftValues, this.cellKey(module, row, col))
      })
      this.$delete(this.addingRows, module.key)
      // 行集合回退，同样校对一次统计标识
      this.refreshModuleStats(module)
    },

    // ─── 新增列 ───────────────────────────────────────
    addColumn(module) {
      if (this.isModuleBusy(module)) return
      const prop = `col_${Date.now()}`
      const label = `维度 ${module.columns.length}`
      // 默认日期类型列（minWidth 随表格自适应）
      module.columns.push({ prop, label, type: 'date', minWidth: 150 })
      module.rows.forEach((row) => {
        this.$set(row, prop, '')
        this.$set(this.draftValues, this.cellKey(module, row, { prop }), '')
      })
      this.$set(this.addingCols, module.key, prop)
    },

    confirmAddColumn(module, col) {
      module.rows.forEach((row) => {
        const key = this.cellKey(module, row, col)
        this.$set(row, col.prop, this.draftValues[key] || '')
        this.$delete(this.draftValues, key)
      })
      this.$delete(this.addingCols, module.key)
      this.persist()
    },

    cancelAddColumn(module, col) {
      const idx = module.columns.indexOf(col)
      if (idx > -1) {
        module.columns.splice(idx, 1)
      }
      module.rows.forEach((row) => {
        this.$delete(this.draftValues, this.cellKey(module, row, col))
        delete row[col.prop]
      })
      this.$delete(this.addingCols, module.key)
    },

    // ─── 删除行 ───────────────────────────────────────
    deleteRow(module, row) {
      this.$confirm('确定删除该行？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const idx = module.rows.indexOf(row)
          if (idx > -1) {
            module.rows.splice(idx, 1)
          }
          // 先落库，成功后再按阵容标识变化决定是否重新 AI 统计
          this.persist().then(() => this.refreshModuleStats(module))
        })
        .catch(() => {})
    },

    // ─── 强度色块 ─────────────────────────────────────
    tierBadgeClass(value) {
      const map = { T0: 'tier-t0', T1: 'tier-t1', T2: 'tier-t2', T3: 'tier-t3' }
      return map[value] || 'tier-none'
    },

    /** 移动端标题图例：该模块内实际存在的强度档位（按 T0→T3 顺序） */
    moduleTierSet(module) {
      const present = new Set()
      ;(module.rows || []).forEach((row) => {
        if (row.strength) present.add(row.strength)
      })
      return this.strengthOptions.filter(t => present.has(t))
    },

    // ─── 标记块（词条色块）维护 ───────────────────────
    genMarkerId() {
      return `mk_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`
    },

    categoryColor(category) {
      const cat = this.markerCategories.find(c => c.name === category)
      return cat ? cat.color : '#78909c'
    },

    /**
     * 初始化类型与词条库：
     * - categories 后端为空 → 内置五类兜底；markers 为空 → 内置默认词条；
     * - 首次自动保存一次，让后端生成/落库（新类型缺色由后端随机分配）。
     */
    initMeta(data) {
      const dataCats = (data && Array.isArray(data.categories)) ? data.categories : []
      const cats = dataCats
        .filter(c => c && String(c.name || '').trim())
        .map(c => ({
          name: String(c.name).trim(),
          color: c.color || this.categoryColor(String(c.name).trim()),
        }))
      this.categories = cats.length ? cats : MARKER_CATEGORIES.map(c => ({ ...c }))

      const dataMarkers = (data && Array.isArray(data.markers)) ? data.markers : []
      const valid = dataMarkers
        .filter(m => m && String(m.name || '').trim())
        .map(m => ({
          id: m.id || this.genMarkerId(),
          name: String(m.name).trim(),
          category: this.categories.some(c => c.name === m.category)
            ? m.category
            : (this.categories[0] ? this.categories[0].name : '玩法'),
          color: m.color || this.categoryColor(m.category),
        }))
      const needPersist = !cats.length || !valid.length
      if (valid.length) {
        this.markers = valid
      } else {
        this.markers = DEFAULT_MARKERS
          .filter(m => this.categories.some(c => c.name === m.category))
          .map(m => ({ ...m }))
      }
      if (needPersist) this.persist()
    },

    // ─── 场景切换 & 阵容卡片（创建/编辑） ────────────
    switchScene(scene) {
      if (this.scene === scene) return
      this.scene = scene
      this.$nextTick(() => {
        // v-show 隐藏/恢复表格后触发 el-table 重新计算列宽
        window.dispatchEvent(new Event('resize'))
      })
    },

    /** 把模块行合并为阵容卡片（阵容场景按记录日期倒序，新在前；无日期排最后） */
    buildLineupCards(modules) {
      const cards = []
      const defaultTab = DETAIL_FIELDS.length ? DETAIL_FIELDS[0].key : 'lineupHeroes'
      ;(modules || []).forEach((module) => {
        ;(module.rows || []).forEach((row) => {
          cards.push({ module, row, _tab: defaultTab })
        })
      })
      cards.sort((a, b) => {
        const da = a.row.date || ''
        const db = b.row.date || ''
        if (!da && !db) return 0
        if (!da) return 1
        if (!db) return -1
        return da < db ? 1 : da > db ? -1 : 0
      })
      return cards
    },

    /** 点击左侧主力阵营：切换筛选并同步数据源 */
    selectCamp(camp) {
      if (this.lineupCamp === camp) return
      this.lineupCamp = camp
      this.syncLineupRows()
    },

    /**
     * 同步阵容视图数据源：无筛选 → 直接用本地全量；
     * 有筛选 → 调用后端接口（GET /api/wzwxq?camp=xx）过滤后回填。
     */
    syncLineupRows() {
      if (!this.lineupCamp) {
        this.lineupRows = null
        return
      }
      const camp = this.lineupCamp
      const seq = (this._lineupSeq = (this._lineupSeq || 0) + 1)
      fetchWzwxqData(camp)
        .then((data) => {
          if (seq !== this._lineupSeq) return
          this.lineupRows = this.buildLineupCards((data && data.modules) || [])
        })
        .catch((error) => {
          if (seq !== this._lineupSeq) return
          console.warn('主力阵营接口过滤失败：', error)
          this.lineupRows = null
        })
    },

    makeRowId() {
      return `new_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
    },

    openCreateDialog(card) {
      if (!card) {
        this.editingCardKey = ''
        this.createForm = {
          moduleKey: '',
          strength: '',
          lineup: '',
          camp: [],
          articleType: '简易',
          detail: '',
          lineupHeroes: '',
          equipment: '',
          operation: '',
          keyTips: '',
          supplement: '',
          date: '',
        }
      } else {
        this.editingCardKey = `${card.module.key}::${card.row.rowId}`
        this.createForm = {
          moduleKey: card.module.key,
          strength: card.row.strength || '',
          lineup: card.row.lineup || '',
          camp: this.campArray(card.row.camp),
          articleType: card.row.articleType === '详细' ? '详细' : '简易',
          detail: card.row.detail || '',
          lineupHeroes: card.row.lineupHeroes || '',
          equipment: card.row.equipment || '',
          operation: card.row.operation || '',
          keyTips: card.row.keyTips || '',
          supplement: card.row.supplement || '',
          date: card.row.date || '',
        }
      }
      this.createDialogVisible = true
    },

    /** 确保存在「未分类」模块（未选择所属环境时数据落库于此） */
    ensureUncategorizedModule() {
      let target = (this.pageData.modules || []).find(m => m.key === 'ban_uncategorized')
      if (!target) {
        target = {
          key: 'ban_uncategorized',
          title: '未分类',
          columns: [
            { prop: 'strength', label: '强度', type: 'strength', fixed: true, width: 110 },
            { prop: 'lineup', label: '阵容', type: 'text', width: 240 },
            { prop: 'detail', label: '打法/要点', type: 'text', minWidth: 320 },
            { prop: 'date', label: '记录日期', type: 'date', width: 118 },
          ],
          rows: [],
        }
        this.pageData.modules.push(target)
      }
      return target
    },

    submitCreateLineup() {
      const form = this.createForm
      // 所属环境可选：未选择时归入「未分类」模块
      const module = form.moduleKey
        ? (this.pageData.modules || []).find(m => m.key === form.moduleKey)
        : this.ensureUncategorizedModule()
      if (!module) return
      if (!String(form.lineup || '').trim()) return this.$toast.warning('请输入阵容名称')

      const isDetail = form.articleType === '详细'
      if (isDetail) {
        if (!String(form.lineupHeroes || '').trim()) return this.$toast.warning('「阵容英雄」为必填项')
      } else if (!String(form.detail || '').trim()) {
        return this.$toast.warning('请输入打法/要点')
      }

      const payload = {
        // 强度可选，留空则存空
        strength: form.strength || '',
        lineup: String(form.lineup).trim(),
        camp: Array.isArray(form.camp) ? form.camp.filter(Boolean) : [],
        articleType: isDetail ? '详细' : '简易',
        detail: String(form.detail || '').trim(),
        // 详细类型的分节内容（均保留换行）
        lineupHeroes: String(form.lineupHeroes || '').trim(),
        equipment: String(form.equipment || '').trim(),
        operation: String(form.operation || '').trim(),
        keyTips: String(form.keyTips || '').trim(),
        supplement: String(form.supplement || '').trim(),
        // 日期留空 → 默认当前时间（与表格逻辑一致）
        date: form.date || this.todayString(),
      }
      let oldModule = null
      if (this.editingCardKey) {
        const [oldKey, rowId] = this.editingCardKey.split('::')
        if (oldKey === module.key) {
          const row = module.rows.find(r => r.rowId === rowId)
          if (row) {
            ;['strength', 'lineup', 'camp', 'articleType', 'detail', 'lineupHeroes', 'equipment', 'operation', 'keyTips', 'supplement', 'date'].forEach((k) => {
              this.$set(row, k, payload[k])
            })
          }
        } else {
          // 编辑时切换了所属环境 → 从旧模块移除，加入新模块
          oldModule = (this.pageData.modules || []).find(m => m.key === oldKey)
          const idx = oldModule ? oldModule.rows.findIndex(r => r.rowId === rowId) : -1
          if (oldModule && idx > -1) oldModule.rows.splice(idx, 1)
          module.rows.unshift({ rowId: rowId || this.makeRowId(), ...payload })
        }
      } else {
        module.rows.unshift({ rowId: this.makeRowId(), ...payload })
      }

      this.createDialogVisible = false
      this.$toast.success(this.editingCardKey ? '阵容已更新' : '阵容已创建')
      this.persist().then(() => {
        this.refreshModuleStats(module)
        if (oldModule) this.refreshModuleStats(oldModule)
      })
    },

    /** 编辑弹窗内删除当前阵容（二次确认） */
    deleteEditingLineup() {
      if (!this.editingCardKey) return
      const [moduleKey, rowId] = this.editingCardKey.split('::')
      const module = (this.pageData.modules || []).find(m => m.key === moduleKey)
      const row = module && module.rows ? module.rows.find(r => r.rowId === rowId) : null
      if (!row) {
        this.$toast.warning('未找到该阵容，可能已被删除')
        this.editingCardKey = ''
        return
      }
      const lineupName = row.lineup || ''
      this.$confirm(`确定删除阵容「${lineupName}」？删除后不可恢复。`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const idx = module.rows.indexOf(row)
          if (idx > -1) module.rows.splice(idx, 1)
          this.createDialogVisible = false
          this.editingCardKey = ''
          this.$toast.success('阵容已删除')
          this.persist().then(() => this.refreshModuleStats(module))
        })
        .catch(() => {})
    },

    openMarkerDialog() {
      this.markersDraft = this.markers.map(m => ({ ...m }))
      this.dialogCategories = this.markerCategories.map(c => ({ ...c }))
      this.editingMarkerId = null
      this.editMarkerName = ''
      this.editMarkerColor = ''
      this.addingCategory = false
      this.editCategoryName = ''
      this.editCategoryColor = ''
      this.markerDialogVisible = true
    },

    // 弹窗打开时锁定页面滚动容器（右侧滚动条消失），关闭后恢复
    lockBackgroundScroll() {
      const holder = this.$el
        ? (this.$el.querySelector('.page-scroll') || this.$el.closest('.content-wrapper'))
        : null
      if (holder) {
        this._scrollLockEl = holder
        this._scrollLockPrev = holder.style.overflow || ''
        holder.style.overflow = 'hidden'
      }
    },
    unlockBackgroundScroll() {
      if (this._scrollLockEl) {
        this._scrollLockEl.style.overflow = this._scrollLockPrev || ''
        this._scrollLockEl = null
      }
    },

    groupMarkers(category) {
      return this.markersDraft.filter(m => m.category === category)
    },

    startEditMarker(marker) {
      this.editingMarkerId = marker.id
      this.editMarkerName = marker.name
      this.editMarkerColor = marker.color || this.categoryColor(marker.category)
    },

    startAddMarker(category) {
      if (this.editingMarkerId) return
      const newId = `__new_${category.name}`
      // 临时词条渲染在对应组内
      this.markersDraft.push({
        id: newId,
        isNew: true,
        name: '',
        category: category.name,
        color: category.color,
      })
      this.editingMarkerId = newId
      this.editMarkerName = ''
      this.editMarkerColor = category.color
    },

    cancelMarkerEdit(marker) {
      if (marker && marker.isNew) {
        const idx = this.markersDraft.indexOf(marker)
        if (idx > -1) this.markersDraft.splice(idx, 1)
      }
      this.editingMarkerId = null
      this.editMarkerName = ''
      this.editMarkerColor = ''
    },

    commitMarkerEdit(marker) {
      const name = String(this.editMarkerName || '').trim()
      if (!name) {
        this.$toast.warning('词条名称不能为空')
        return
      }
      const duplicated = this.markersDraft.some(
        other => other.id !== marker.id && String(other.name || '').trim() === name
      )
      if (duplicated) {
        this.$toast.warning(`已存在同名词条「${name}」，请勿重复添加`)
        return
      }
      if (marker.isNew) {
        marker.id = this.genMarkerId()
        marker.isNew = false
      }
      marker.name = name
      marker.color = this.editMarkerColor || this.categoryColor(marker.category)
      this.editingMarkerId = null
      this.editMarkerName = ''
      this.editMarkerColor = ''
    },

    deleteMarker(marker) {
      this.$confirm(`确定删除词条「${marker.name}」？删除后表格将不再高亮该词。`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const idx = this.markersDraft.indexOf(marker)
          if (idx > -1) this.markersDraft.splice(idx, 1)
          if (this.editingMarkerId === marker.id) this.editingMarkerId = null
        })
        .catch(() => {})
    },

    // ─── 类型（分组）维护 ─────────────────────────────
    startAddCategory() {
      if (this.addingCategory) return
      this.addingCategory = true
      this.editCategoryName = ''
      this.editCategoryColor = ''
    },

    cancelCategoryAdd() {
      this.addingCategory = false
      this.editCategoryName = ''
      this.editCategoryColor = ''
    },

    commitCategoryAdd() {
      const name = String(this.editCategoryName || '').trim()
      if (!name) {
        this.$toast.warning('请输入类型名称')
        return
      }
      if (this.dialogCategories.some(c => c.name === name)) {
        this.$toast.warning(`已存在类型「${name}」`)
        return
      }
      // 颜色可空：保存时由后端随机分配未占用颜色
      this.dialogCategories.push({ name, color: this.editCategoryColor || '' })
      this.addingCategory = false
      this.editCategoryName = ''
      this.editCategoryColor = ''
    },

    deleteCategory(cat) {
      if (this.groupMarkers(cat.name).length) {
        this.$toast.warning(`类型「${cat.name}」下仍有词条，请先删除该组词条`)
        return
      }
      const idx = this.dialogCategories.indexOf(cat)
      if (idx > -1) this.dialogCategories.splice(idx, 1)
    },

    saveMarkers() {
      // 未提交的「新增类型」：有名称则并入，否则丢弃
      if (this.addingCategory) {
        const catName = String(this.editCategoryName || '').trim()
        if (catName && !this.dialogCategories.some(c => c.name === catName)) {
          this.dialogCategories.push({ name: catName, color: this.editCategoryColor || '' })
        }
        this.addingCategory = false
      }
      // 若有未提交的新增/编辑行：先自动提交（名称为空的新增行直接丢弃）
      if (this.editingMarkerId) {
        const editing = this.markersDraft.find(m => m.id === this.editingMarkerId)
        if (editing) {
          if (editing.isNew && !String(this.editMarkerName || '').trim()) {
            const idx = this.markersDraft.indexOf(editing)
            if (idx > -1) this.markersDraft.splice(idx, 1)
          } else {
            this.commitMarkerEdit(editing)
          }
        }
        this.editingMarkerId = null
      }
      const list = this.markersDraft
        .filter(m => !m.isNew && String(m.name || '').trim())
        .map(m => ({
          id: m.id,
          name: String(m.name).trim(),
          category: m.category,
          color: m.color || this.categoryColor(m.category),
        }))

      // 类型列表：名称去重（空颜色保留，由后端随机分配）
      const seenNames = new Set()
      const cats = this.dialogCategories
        .filter(c => c && String(c.name || '').trim())
        .filter((c) => {
          const n = String(c.name).trim()
          if (seenNames.has(n)) return false
          seenNames.add(n)
          return true
        })
        .map(c => ({ name: String(c.name).trim(), color: c.color || '' }))

      this.categories = cats
      this.markers = list
      this.markerDialogVisible = false
      this.persist().then((saved) => {
        // 后端已为缺色类型随机分配颜色，刷新本地（下次打开弹窗分组即显示新色）
        if (saved && Array.isArray(saved.categories) && saved.categories.length) {
          this.categories = saved.categories
        }
        this.$toast.success(`标记块已保存（${list.length} 个词条 / ${cats.length} 个类型），表格已重新匹配`)
      })
    },

    // ─── 文本匹配 → 色块渲染 ─────────────────────────
    /** 判断文本是否为图片资源 URL（http(s) 且以常见图片后缀结尾） */
    isImageUrl(text) {
      if (!text) return false
      const s = String(text).trim()
      if (!s) return false
      if (!/^https?:\/\/\S+$/i.test(s)) return false
      const path = s.split(/[?#]/)[0]
      return /\.(png|jpe?g|gif|webp|bmp|svg|avif|ico)$/i.test(path)
    },

    /** 把纯文本切成普通片段与词条色块片段（长词优先，同一位置只命中一次） */
    matchDetailTokens(text) {
      const source = String(text || '')
      if (!source) return []
      const markers = this.markers.filter(m => m && String(m.name || '').trim())
      if (!markers.length) return [{ type: 'text', content: source }]
      const sorted = markers
        .map(m => ({ name: String(m.name).trim(), color: m.color }))
        .sort((a, b) => b.name.length - a.name.length)

      const tokens = []
      let rest = source
      while (rest) {
        let best = null
        for (let i = 0; i < sorted.length; i += 1) {
          const idx = rest.indexOf(sorted[i].name)
          if (idx > -1 && (best === null || idx < best.idx)) {
            best = { idx, marker: sorted[i] }
          }
        }
        if (!best) {
          tokens.push({ type: 'text', content: rest })
          break
        }
        if (best.idx > 0) {
          tokens.push({ type: 'text', content: rest.slice(0, best.idx) })
        }
        tokens.push({ type: 'tag', content: best.marker.name, color: best.marker.color })
        rest = rest.slice(best.idx + best.marker.name.length)
      }
      return tokens
    },

    /** 依据背景色亮度自动选择前景文字色 */
    textColorFor(hex) {
      const value = String(hex || '').replace('#', '')
      if (!/^[0-9a-fA-F]{6}$/.test(value)) return '#ffffff'
      const r = parseInt(value.slice(0, 2), 16)
      const g = parseInt(value.slice(2, 4), 16)
      const b = parseInt(value.slice(4, 6), 16)
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
      return luminance > 0.68 ? '#333333' : '#ffffff'
    },

    markerChipStyle(token) {
      return { backgroundColor: token.color, color: this.textColorFor(token.color) }
    },

    markerStyleOf(marker) {
      return { backgroundColor: marker.color, color: this.textColorFor(marker.color) }
    },

    /** 主力阵营色块样式 */
    campChipStyle(camp) {
      const color = CAMP_COLORS[camp] || '#90a4ae'
      return { backgroundColor: color, color: this.textColorFor(color) }
    },

    /** 行内 camp（字符串或数组）规范化为数组 */
    campArray(value) {
      if (!value) return []
      const list = Array.isArray(value) ? value : [value]
      return list.map(v => String(v || '').trim()).filter(Boolean)
    },

    // ─── AI 高频阵容统计（DeepSeek，参考 AI demo 直连） ─
    /**
     * 阵容列签名：把模块内每条数据的阵容值（清洗后）作为标识，
     * 排序拼接。签名一致 ⇒ 阵容没多没少没改，统计结果可直接复用。
     */
    computeLineupSignature(module) {
      return (module.rows || [])
        .map(row => (row.lineup == null ? '' : String(row.lineup).trim()))
        .filter(Boolean)
        .sort()
        .join('\u0001')
    },

    readStatsCache() {
      try {
        return JSON.parse(localStorage.getItem(STATS_CACHE_KEY) || '{}') || {}
      } catch (error) {
        console.warn('Failed to read wzwxq stats cache:', error)
        return {}
      }
    },

    saveStatsCache(moduleKey, signature, result) {
      try {
        const cache = this.readStatsCache()
        cache[moduleKey] = { signature, result, ts: Date.now() }
        localStorage.setItem(STATS_CACHE_KEY, JSON.stringify(cache))
      } catch (error) {
        console.warn('Failed to save wzwxq stats cache:', error)
      }
    },

    // 数据加载完成后：逐模块决定初始统计状态。
    // 签名与上次一致 → 直接亮出上次统计结果；否则先显示表格，后台请求 AI。
    settleAllStats() {
      ;(this.pageData.modules || []).forEach((module) => {
        const signature = this.computeLineupSignature(module)
        const cached = this.readStatsCache()[module.key]
        if (cached && cached.signature === signature) {
          this.$set(this.stats, module.key, { status: 'ok', result: cached.result || [] })
        } else {
          // 先返回表格数据、暂不显示统计，等待 AI 完成后更新
          this.$set(this.stats, module.key, { status: 'pending', result: [] })
          this.runModuleStats(module, false)
        }
      })
    },

    /**
     * 数据变更后的统计校对：仅当本次阵容签名相对上次统计结果
     * “少了某个 / 多了某个 / 改动了某个”时才重新请求 AI；
     * 签名未变则直接复用缓存结果展示。
     */
    refreshModuleStats(module) {
      if (!module) return
      // 行数据变化后同步阵容视图数据源（无筛选 → 本地全量；有筛选 → 重新走接口）
      this.syncLineupRows()
      const signature = this.computeLineupSignature(module)
      const cached = this.readStatsCache()[module.key]
      if (cached && cached.signature === signature) {
        this.$set(this.stats, module.key, { status: 'ok', result: cached.result || [] })
        return
      }
      // 签名变化：先隐藏统计（保留表格数据展示），请求 AI 后更新
      this.$set(this.stats, module.key, { status: 'pending', result: [] })
      this.runModuleStats(module, false)
    },

    getDeepSeekConfig() {
      try {
        const raw = localStorage.getItem(DEEPSEEK_STORAGE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed || !parsed.apiKey) return null
        return { apiKey: parsed.apiKey, model: parsed.model || 'deepseek-chat' }
      } catch (error) {
        console.warn('Failed to read DeepSeek config:', error)
        return null
      }
    },

    runModuleStats(module, force = false) {
      if (!module) return
      const key = module.key
      const signature = this.computeLineupSignature(module)

      // 非强制且签名与上次统计一致 → 复用缓存，不发 AI 请求
      const cached = this.readStatsCache()[key]
      if (!force && cached && cached.signature === signature) {
        this.$set(this.stats, key, { status: 'ok', result: cached.result || [] })
        return
      }

      // 中止该模块上一次未完成的请求
      if (this.statsAbort && this.statsAbort[key]) {
        this.statsAbort[key].abort()
        this.statsAbort[key] = null
      }

      const config = this.getDeepSeekConfig()
      if (!config) {
        this.$set(this.stats, key, { status: 'no-key', result: [] })
        if (force) this.$toast.warning('未检测到 DeepSeek API Key，请先在「AI → DeepSeek 问答」中配置')
        return
      }

      const controller = new AbortController()
      if (!this.statsAbort) this.statsAbort = {}
      this.statsAbort[key] = controller
      this.$set(this.stats, key, { status: 'loading', result: [] })

      const lineups = (module.rows || [])
        .map(row => (row.lineup != null ? String(row.lineup).trim() : ''))
        .filter(Boolean)

      this.askDeepSeek(config, this.buildStatsPrompt(module, lineups), controller.signal)
        .then((content) => {
          const result = this.parseStatsAnswer(content)
          this.saveStatsCache(key, signature, result)
          this.$set(this.stats, key, { status: 'ok', result })
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return
          console.warn(`wzwxq AI stats failed for ${module.title}:`, error)
          this.$set(this.stats, key, { status: 'failed', result: [] })
        })
        .finally(() => {
          if (this.statsAbort && this.statsAbort[key] === controller) {
            this.statsAbort[key] = null
          }
        })
    },

    abortAllStats() {
      if (!this.statsAbort) return
      Object.keys(this.statsAbort).forEach((key) => {
        if (this.statsAbort[key]) this.statsAbort[key].abort()
      })
      this.statsAbort = {}
    },

    /**
     * AI 统计提示词：让 DeepSeek 从本模块「阵容」列数组中，
     * 找出出现次数超过 2 次（>=3）的阵容词眼，仅返回 JSON。
     */
    buildStatsPrompt(module, lineups) {
      return [
        `以下是《王者万象棋》「${module.title}」禁用环境下阵容排行表格中「阵容」列的全部取值（JSON 数组）：`,
        JSON.stringify(lineups),
        '',
        '请统计其中出现次数超过 2 次（即出现次数 >= 3）的“阵容词眼”。统计规则：',
        '1. 先按完整阵容名去重计数，例如“马可养猪（备选）”应归并计入“马可养猪”；',
        '2. 若完整阵容名没有超过 2 次的，再提取多个阵容名之间反复出现的核心词根计数，',
        '   例如“日落海倒转”与“日落海司空震”共享词根“日落海”，视为同一词眼各计一次；',
        '3. “弈星 / 日落海司空震”这类“A / B”写法只代表一次出场，不要拆成两个阵容分别计数。',
        '',
        '只输出一个 JSON 数组，数组元素格式为 {"name":"词眼","count":出现次数}，按 count 降序排列；',
        '如果没有超过 2 次的词眼，输出 []。不要输出任何解释、注释或多余文字。',
      ].join('\n')
    },

    askDeepSeek(config, prompt, signal) {
      const controller = new AbortController()
      const timer = setTimeout(() => controller.abort(), DEEPSEEK_TIMEOUT)
      const mergedSignal = signal || controller.signal
      mergedSignal.addEventListener('abort', () => controller.abort(), { once: true })
      return fetch(DEEPSEEK_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${config.apiKey}`,
        },
        body: JSON.stringify({
          model: config.model,
          temperature: 0,
          stream: false,
          messages: [
            { role: 'system', content: '你是游戏阵容数据分析助手。你只输出严格合法的 JSON，不输出任何其它文字。' },
            { role: 'user', content: prompt },
          ],
        }),
        signal: controller.signal,
      })
        .then(async (response) => {
          if (!response.ok) {
            const text = await response.text().catch(() => '')
            throw new Error(`DeepSeek 请求失败(${response.status})：${String(text).slice(0, 200)}`)
          }
          const data = await response.json()
          const content = data && data.choices && data.choices[0] &&
            data.choices[0].message && data.choices[0].message.content
          return content || ''
        })
        .finally(() => clearTimeout(timer))
    },

    parseStatsAnswer(content) {
      if (!content) return []
      let text = String(content).trim()
      // 剥离可能的 markdown 代码块围栏
      text = text.replace(/^```(?:json)?\s*/i, '').replace(/```\s*$/, '')
      const arrayMatch = text.match(/\[[\s\S]*\]/)
      if (arrayMatch) text = arrayMatch[0]
      try {
        const parsed = JSON.parse(text)
        const list = Array.isArray(parsed) ? parsed : (Array.isArray(parsed.result) ? parsed.result : [])
        return list
          .map((item) => ({
            name: String(item.name || item.word || item.keyword || '').trim(),
            count: Number(item.count || item.times || item.frequency || 0),
          }))
          .filter(item => item.name && item.count >= 3)
          .sort((a, b) => b.count - a.count)
      } catch (error) {
        console.warn('Failed to parse DeepSeek stats answer:', error, String(content).slice(0, 300))
        return []
      }
    },

    // ─── 左侧模块导航：平滑滚动 + 滚动高亮 ────────────
    initScrollSpy() {
      this.destroyScrollSpy()
      // 页面滚动发生在组件内部 .page-scroll（顶部标题固定）
      let container = this.$el ? this.$el.querySelector('.page-scroll') : null
      if (!container) container = window
      this.scrollContainer = container
      this.scrollHandler = () => this.syncActiveModule()
      if (container === window) {
        window.addEventListener('scroll', this.scrollHandler, { passive: true })
      } else {
        container.addEventListener('scroll', this.scrollHandler, { passive: true })
      }
      // 滚动容器尺寸变化（如折叠侧栏）后重新计算
      window.addEventListener('resize', this.scrollHandler, { passive: true })
      this.syncActiveModule()
    },

    destroyScrollSpy() {
      if (this.scrollHandler) {
        window.removeEventListener('resize', this.scrollHandler)
        if (this.scrollContainer && this.scrollContainer !== window) {
          this.scrollContainer.removeEventListener('scroll', this.scrollHandler)
        } else {
          window.removeEventListener('scroll', this.scrollHandler)
        }
      }
      this.scrollHandler = null
      this.scrollContainer = null
    },

    syncActiveModule() {
      if (!this.$el) return
      const blocks = Array.prototype.slice.call(this.$el.querySelectorAll('.module-block'))
      if (!blocks.length) return
      const container = this.scrollContainer || window
      const containerTop = container === window ? 0 : container.getBoundingClientRect().top
      // 基准线：滚动容器可视区顶部向下 60px（内容滚动区自身顶部即模块区）
      const hitLine = containerTop + 60
      let activeKey = ''
      blocks.forEach((el) => {
        const rect = el.getBoundingClientRect()
        if (rect.top <= hitLine) {
          activeKey = el.getAttribute('data-module-key') || ''
        }
      })
      if (this.activeModuleKey !== activeKey) {
        this.activeModuleKey = activeKey
      }
    },

    scrollToModule(module) {
      const el = this.$el.querySelector(`.module-block[data-module-key="${module.key}"]`)
      if (!el) return
      this.activeModuleKey = module.key
      const container = this.scrollContainer || window
      if (container === window) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        const targetTop =
          el.getBoundingClientRect().top -
          container.getBoundingClientRect().top +
          container.scrollTop -
          14
        container.scrollTo({ top: targetTop, behavior: 'smooth' })
      }
    },
  },
}
</script>

<style scoped>
/* ================= 页面骨架：左导航 + 右主体（标题固定，内容独立滚动） ================= */
.wzwxq-page {
  display: flex;
  align-items: stretch;
  gap: 18px;
  /* 撑满内容区；移动端独立模式下由 Layout 的 .standalone-page 提供高度 */
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter, system-ui, -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif';
}

.page-body {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ================= 左侧常驻模块导航 ================= */
.side-nav {
  flex-shrink: 0;
  align-self: flex-start;
  width: 176px;
  background: var(--surface-1);
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: var(--shadow-surface-1);
  overflow: hidden;
}

.side-nav__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border-bottom: 1px solid rgba(31, 45, 61, 0.05);
}

.side-nav__title {
  font-size: 13px;
  font-weight: 700;
  color: #303133;
}

.side-nav__count {
  font-size: 11px;
  color: #a8abb2;
}

.side-nav__list {
  list-style: none;
  margin: 0;
  padding: 6px;
}

.side-nav__item {
  display: block;
  padding: 9px 12px;
  margin-bottom: 2px;
  font-size: 14px;
  color: #606266;
  border-radius: 7px;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.4;
  transition: all 0.25s ease;
  user-select: none;
}

.side-nav__item:hover {
  background: #f0f6ff;
  color: #409eff;
}

.side-nav__item.active {
  background: #409eff;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.35);
}

/* ================= 顶部固定区：大标题 + 场景切换 ================= */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 16px;
  padding: 2px 6px 12px;
  flex-shrink: 0;
}

.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2d3d;
  margin: 0;
  letter-spacing: 0.5px;
  line-height: 1.4;
}

/* 场景切换块：选中样式与左侧模块导航一致 */
.scene-switch {
  display: inline-flex;
  align-items: center;
  background: #eef1f6;
  border-radius: 999px;
  padding: 3px;
  flex-shrink: 0;
}

.scene-switch__item {
  padding: 5px 16px;
  font-size: 13px;
  color: #606266;
  border-radius: 999px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.scene-switch__item:hover {
  color: #409eff;
}

.scene-switch__item.active {
  background: #409eff;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.35);
}

/* 内容滚动区 */
.page-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 6px 24px;
}

/* ================= 模块区块 ================= */
.module-block {
  background: var(--surface-1);
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-surface-2);
  /* 平滑滚动定位留白 */
  scroll-margin-top: 14px;
}

.module-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.module-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.4;
  flex-shrink: 0;
}

/* ================= AI 高频阵容统计 ================= */
.module-stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.stats-label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 600;
  color: #2b5bd7;
  margin-right: 2px;
}

.stats-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 10px;
  font-size: 12px;
  color: #1f2d3d;
  background: #eef4ff;
  border: 1px solid #cfe0ff;
  border-radius: 999px;
  white-space: nowrap;
}

.stats-chip b {
  color: #d4380d;
  font-weight: 700;
  font-size: 12px;
  /* 等宽数字锁死：高频阵容计数变化不引起布局抖动 */
  font-variant-numeric: tabular-nums;
  -webkit-font-variant-numeric: tabular-nums;
}

.stats-note {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2b5bd7;
}

.stats-note.is-muted {
  color: #a8abb2;
}

.stats-refresh {
  font-size: 13px;
  color: #909399;
  cursor: pointer;
  padding: 3px;
  border-radius: 50%;
  transition: color 0.2s, background 0.2s;
}

.stats-refresh:hover {
  color: #409eff;
  background: #f0f6ff;
}

.stats-refresh.is-loading {
  animation: rotating 1s linear infinite;
}

/* 降级：系统偏好减少动态效果时关闭刷新旋转动画 */
@media (prefers-reduced-motion: reduce) {
  .stats-refresh.is-loading {
    animation: none;
  }
}

@keyframes rotating {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.module-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

/* ================= 表格容器（随页面撑满） ================= */
.table-wrap {
  width: 100%;
}

.wzwxq-table {
  width: 100% !important;
}

/* ================= 单元格 ================= */
.cell-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 30px;
}

.cell-wrap.is-editing {
  gap: 4px;
}

.cell-text {
  flex: 1;
  font-size: 13px;
  color: #303133;
  white-space: normal;
  line-height: 1.4;
  word-break: break-all;
}

.cell-control {
  flex: 1;
  width: 100%;
}

/* ================= 强度色块 ================= */
.tier-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 1px 12px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  flex-shrink: 0;
}

/* 移动端模块标题右侧的强度图例 */
.m-tier-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}

.tier-legend-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  padding: 1px 8px;
  border-radius: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
}

/* 强度徽章色（深色徽章系，与打法中鲜亮的词条色块区分）：
   T0 鎏金 / T1 青碧 / T2 暗紫 / T3 蓝灰 */
.tier-t0 {
  background: linear-gradient(135deg, #ffca28, #d19a00);
  box-shadow: 0 2px 8px rgba(209, 154, 0, 0.45);
}

.tier-t1 {
  background: linear-gradient(135deg, #2fc4b8, #009e93);
  box-shadow: 0 2px 6px rgba(0, 158, 147, 0.35);
}

.tier-t2 {
  background: linear-gradient(135deg, #8e6bff, #5e35b1);
  box-shadow: 0 2px 6px rgba(94, 53, 177, 0.32);
}

.tier-t3 {
  background: linear-gradient(135deg, #90a4ae, #78909c);
}

.tier-none {
  background: #c0c4cc;
}

/* ================= 操作按钮 ================= */
.row-edit-btn {
  color: #409eff;
  font-size: 16px;
  padding: 2px;
  flex-shrink: 0;
}

.row-delete-btn {
  color: #f56c6c;
  font-size: 16px;
  padding: 2px;
  flex-shrink: 0;
}

.cell-confirm-btn,
.col-confirm-btn,
.row-confirm-btn {
  color: #67c23a;
  font-size: 16px;
  padding: 2px;
  flex-shrink: 0;
}

.col-cancel-btn,
.row-cancel-btn {
  color: #f56c6c;
  font-size: 16px;
  padding: 2px;
}

.col-head-editing {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

/* ================= 日期蓝色色块 ================= */
.date-pill {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 1px 9px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 20px;
  color: #ffffff;
  background: linear-gradient(135deg, #42a5f5, #1e88e5);
  box-shadow: 0 1px 4px rgba(30, 136, 229, 0.3);
}

/* 阵容列单行完整显示（超长省略，title 全文） */
.cell-text.is-nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 打法/要点为图片 URL 时的 el-image 容器 */
.detail-image {
  display: block;
  width: 120px;
  height: 70px;
  border-radius: 6px;
  background: var(--surface-2);
  border: 1px solid #ebeef5;
  cursor: zoom-in;
}

/* ================= 词条色块（表格内高亮） ================= */
/* 打法/要点列：单个流式容器，文本与色块自然排布、可换行 */
.detail-rich {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #303133;
  line-height: 1.7;
}

.marker-chip {
  display: inline-block;
  vertical-align: middle;
  margin: 0 3px;
  padding: 0 8px;
  border-radius: 5px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.14);
  cursor: default;
}

/* ================= 标记块弹窗 ================= */
.marker-dialog__tip {
  font-size: 12px;
  color: #909399;
  background: var(--surface-1);
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 12px;
  line-height: 1.6;
}

/* 类型数据区：占满弹窗 body 剩余高度，超出时仅内部滚动（弹窗整体不超高） */
.marker-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
  margin-right: -4px;
}

/* 弹窗 body 顶部两块固定不压缩 */
.marker-dialog__tip,
.marker-category-add {
  flex-shrink: 0;
}

.marker-group {
  border: 1px solid rgba(31, 45, 61, 0.06);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 10px;
}

.marker-group__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.marker-group__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.marker-group__name {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
}

.marker-group__count {
  font-size: 12px;
  color: #a8abb2;
  background: var(--surface-2);
  border-radius: 999px;
  padding: 0 8px;
  line-height: 18px;
}

/* 新增类型工具栏 */
.marker-category-add {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}

.marker-category-add__hint {
  font-size: 12px;
  color: #a8abb2;
}

.marker-cat-del-btn {
  color: #f56c6c;
  font-size: 13px;
  padding: 0 2px;
  margin-left: auto;
}

.marker-group__add {
  margin-left: auto;
  color: #409eff;
  font-size: 12px;
  padding: 0;
}

.marker-group__body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 28px;
}

.marker-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.marker-chip.is-in-dialog {
  cursor: pointer;
  font-size: 13px;
  padding: 2px 12px;
  line-height: 22px;
  border-radius: 6px;
}

.marker-chip.is-in-dialog:hover {
  opacity: 0.82;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
}

.marker-group__empty {
  font-size: 12px;
  color: #c0c4cc;
}

.marker-edit-name {
  width: 150px;
}

.marker-edit-color {
  vertical-align: middle;
}

.marker-del-btn {
  color: #f56c6c;
  font-size: 15px;
  padding: 2px;
}

.marker-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.marker-dialog__hint {
  margin-right: auto;
  font-size: 12px;
  color: #a8abb2;
}

/* ================= 侧导航固定功能块 ================= */
.side-nav__footer {
  padding: 10px 12px;
  border-top: 1px solid rgba(31, 45, 61, 0.06);
}

.marker-open-btn {
  width: 100%;
  margin: 0;
}

/* 万象棋知识站外链按钮：a 包裹 el-button，需块级铺满 */
.side-nav__link {
  display: block;
  width: 100%;
}

.side-nav__link:hover {
  text-decoration: none;
}

/* 侧导航底部功能块：按钮纵排 */
.side-nav__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 阵容场景左侧：主力阵营筛选列表 */
.side-camp__list {
  padding-top: 8px;
}

.side-camp__hint {
  padding: 2px 14px 12px;
  font-size: 11px;
  color: #a8abb2;
  word-break: break-all;
}

/* ================= 窄屏适配 ================= */
@media (max-width: 1024px) {
  .side-nav {
    display: none;
  }
}

/* ================= 移动端（<=768px）单列列表 ================= */
/* 阵容色块：以强度对应颜色为底展示阵容名 */
.lineup-badge {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 9px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.5px;
  white-space: normal;
  word-break: break-word;
}

.mobile-rows {
  border: 1px solid rgba(31, 45, 61, 0.06);
  border-radius: 8px;
  background: var(--surface-1);
  overflow: hidden;
}

.mobile-col-head {
  padding: 8px 14px;
  background: var(--surface-2);
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px solid rgba(31, 45, 61, 0.06);
}

.m-row {
  padding: 12px 14px;
  border-bottom: 1px solid rgba(31, 45, 61, 0.05);
}

.m-row:last-child {
  border-bottom: none;
}

.m-row__lineup {
  margin-bottom: 8px;
}

.m-row__lineup-text {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
}

.m-row__detail {
  font-size: 13px;
  color: #303133;
  line-height: 1.75;
  word-break: break-word;
  white-space: normal;
}

/* 卡片内的打法图片 */
.detail-image.is-card {
  width: 100%;
  height: 200px;
}

/* ================= 阵容场景：卡片视图 ================= */
.lineup-view {
  padding-bottom: 8px;
}

/* 创建阵容按钮桌面端在左侧栏（标记块下方），此工具栏仅移动端（无侧栏）显示 */
.lineup-toolbar {
  display: none;
}

.lineup-cards {
  display: grid;
  /* 宽屏桌面：每行最多 4 张卡片 */
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

/* 详细文章类型（含 tab 分节，内容更多）：跨 2 列占据更大宽度 */
.lineup-card.is-detail {
  grid-column: span 2;
}

/* 中屏：内容区不足以舒适排 4 列时降为 3 列（详情卡仍跨 2/3 行宽） */
@media (min-width: 769px) and (max-width: 1279px) {
  .lineup-cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.lineup-card {
  display: flex;
  flex-direction: column;
  background: var(--surface-1);
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 16px 18px 14px;
  box-shadow: var(--shadow-surface-1);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

/* 悬浮上移动画 */
.lineup-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
}

.lc-title {
  font-size: 17px;
  font-weight: 700;
  color: #1f2d3d;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(31, 45, 61, 0.05);
  word-break: break-word;
  cursor: pointer;
  transition: color 0.2s ease;
}

.lc-title:hover {
  color: #409eff;
}

.lc-detail {
  flex: 1;
  font-size: 13px;
  color: #303133;
  line-height: 1.75;
  word-break: break-word;
  white-space: normal;
  margin-bottom: 12px;
}

/* 详细类型：卡片内 tab 分节 */
.lc-detail-tabs {
  flex: 1;
  min-height: 0;
  margin-bottom: 12px;
}

.lc-tabs ::v-deep .el-tabs__header {
  margin-bottom: 10px;
}

.lc-tabs ::v-deep .el-tabs__item {
  font-size: 12px;
  height: 34px;
  line-height: 34px;
  padding: 0 12px;
}

.lc-tab-content {
  font-size: 13px;
  color: #303133;
  line-height: 1.75;
  word-break: break-word;
  white-space: pre-line;
  max-height: 260px;
  overflow-y: auto;
}

.lc-tab-empty {
  color: #c0c4cc;
}

.lc-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(31, 45, 61, 0.06);
}

.lc-foot__left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.lc-strength {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 1px 12px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #ffffff;
  line-height: 22px;
}

.lc-date {
  font-size: 12px;
  color: #1e88e5;
  background: #e3f2fd;
  border-radius: 6px;
  padding: 2px 9px;
  white-space: nowrap;
}

/* 主力阵营色块 */
.camp-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
}

.lineup-empty {
  text-align: center;
  color: #a8abb2;
  padding: 40px 0;
  font-size: 13px;
}

/* ================= 创建阵容弹窗表单 ================= */
.create-form__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}

.create-form__label {
  flex-shrink: 0;
  width: 76px;
  text-align: right;
  line-height: 32px;
  font-size: 13px;
  color: #606266;
}

.create-form__control {
  flex: 1;
}

.create-form__footer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.create-form__footer-space {
  flex: 1;
}

.create-form__del {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .wzwxq-page {
    padding: 2px 8px 28px;
    gap: 10px;
  }

  .page-header {
    margin-bottom: 12px;
  }

  .page-title {
    font-size: 19px;
    letter-spacing: 0.3px;
    line-height: 1.5;
  }

  .module-block {
    padding: 10px 8px;
    margin-bottom: 12px;
    border-radius: 8px;
  }

  .module-head {
    gap: 6px;
    margin-bottom: 10px;
  }

  .module-title {
    font-size: 16px;
    padding-left: 8px;
    border-left-width: 3px;
    order: 1;
  }

  .m-tier-legend {
    order: 1;
  }

  .module-actions {
    order: 2;
    margin-left: auto;
  }

  .module-stats {
    order: 3;
    flex: 1 1 100%;
    margin-left: 0;
  }

  .stats-chip,
  .stats-note {
    font-size: 11px;
  }

  .cell-text {
    font-size: 12px;
  }

  .date-pill {
    font-size: 11px;
    padding: 0 7px;
  }

  .marker-chip {
    font-size: 11px;
    line-height: 18px;
    padding: 0 6px;
    margin: 0 2px;
  }
}

/* ============ 移动端补充（覆盖桌面规则） ============ */
@media (max-width: 768px) {
  .wzwxq-page {
    padding: 0 2px 2px;
    gap: 8px;
  }

  .page-header {
    padding: 2px 2px 10px;
    gap: 6px 10px;
    margin-bottom: 0;
  }

  .page-title {
    font-size: 17px;
  }

  .page-scroll {
    padding: 0 2px 20px;
  }

  .lineup-cards {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  /* 移动端单列：详细类型卡片不再跨列 */
  .lineup-card.is-detail {
    grid-column: auto;
  }

  .lineup-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .lineup-toolbar {
    margin-bottom: 10px;
  }

  .lineup-card {
    padding: 12px 14px 12px;
  }

  .create-form__label {
    width: 64px;
  }
}
</style>

<style>
/* ===== 标记块弹窗：固定高度，类型列表内部滚动 =====
   非 scoped：el-dialog 内部结构由子组件渲染，需全局命中 */
.marker-dialog .el-dialog {
  margin-top: 5vh;
  height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
}

.marker-dialog .el-dialog__header {
  flex-shrink: 0;
}

.marker-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-bottom: 8px;
}

.marker-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding-top: 10px;
}

.marker-dialog .el-dialog__title {
  font-size: 16px;
}

/* 小屏兜底：弹窗宽度自适应 */
@media (max-width: 720px) {
  .marker-dialog {
    width: 94vw !important;
  }
}

/* ===== 创建阵容弹窗：表单区内部滚动 ===== */
.create-lineup-dialog .el-dialog {
  margin: 24px auto 24px;
  display: flex;
  flex-direction: column;
}

.create-lineup-dialog .el-dialog__header {
  flex-shrink: 0;
}

.create-lineup-dialog .el-dialog__body {
  height: 500px !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-bottom: 8px;
}

.create-lineup-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding-top: 10px;
}

.create-lineup-dialog .create-form {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.create-lineup-dialog .create-form-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

@media (max-width: 720px) {
  .create-lineup-dialog {
    width: 94vw !important;
  }
}
</style>
